import { render, staticRenderFns } from "./SupporterSendUpdateDetails.vue?vue&type=template&id=6525bb2a&"
import script from "./SupporterSendUpdateDetails.vue?vue&type=script&lang=js&"
export * from "./SupporterSendUpdateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6525bb2a')) {
      api.createRecord('6525bb2a', component.options)
    } else {
      api.reload('6525bb2a', component.options)
    }
    module.hot.accept("./SupporterSendUpdateDetails.vue?vue&type=template&id=6525bb2a&", function () {
      api.rerender('6525bb2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Donations/SupporterSendUpdateDetails.vue"
export default component.exports